import cx from 'classnames';
import type { User } from '@/lib/types';
import styles from './UserCrumb.module.css';

export const UserCrumb = ({ user, className }: { user: User, className?: string }) => {
  return (
    <div className={cx(styles.userCrumb, className)}>
      <img src={user.image} alt={user.name} height="24" width="24" />
      <div className={styles.userName}>
        {user.name}
      </div>
    </div>
  );
};
